const rankItems = [
  { rank: 1, title: '某顶流艺人私下交易被曝光', heat: '980万', tag: '娱乐圈', trend: 'up' },
  { rank: 2, title: '知名企业财报造假内幕流出', heat: '860万', tag: '商业', trend: 'up' },
  { rank: 3, title: '网红圈最新撕逼大战全程记录', heat: '750万', tag: '网红', trend: 'hot' },
  { rank: 4, title: '某平台数据泄露涉及百万用户', heat: '620万', tag: '科技', trend: 'up' },
  { rank: 5, title: '综艺节目幕后黑幕深度起底', heat: '510万', tag: '综艺', trend: 'new' },
];

function RankBadge({ rank }: { rank: number }) {
  const colors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-background-400', 'bg-background-400'];
  return (
    <span
      className={`w-7 h-7 flex items-center justify-center rounded-md text-white text-xs font-extrabold shrink-0 ${colors[rank - 1]}`}
    >
      {rank}
    </span>
  );
}

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
              热门榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              实时热度排行，看看大家都在关注什么
            </p>
          </div>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line" />
            每10分钟更新
          </span>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100 cursor-pointer ${
                i < rankItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.tag}</span>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs font-bold text-primary-600">{item.heat}</span>
                <span className="text-xs text-foreground-400">热度</span>
                {item.trend === 'hot' && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-fire-fill text-accent-500 text-sm" />
                  </span>
                )}
                {item.trend === 'up' && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-up-fill text-primary-500 text-sm" />
                  </span>
                )}
                {item.trend === 'new' && (
                  <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-bold">
                    NEW
                  </span>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}